import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getProjects, resolveImg } from "@/lib/api";
import { useContent } from "@/context/ContentContext";

export const Casos = () => {
  const { casos: c } = useContent();
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    getProjects().then(setProjects).catch(() => setProjects([]));
  }, []);

  return (
    <section id="casos" className="dk" data-testid="casos">
      <div
        className="wrap"
        style={{
          paddingTop: "clamp(80px,10vw,140px)",
          paddingBottom: "clamp(40px,5vw,72px)",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "flex-end",
          gap: 24,
        }}
      >
        <div>
          <p className="lb" style={{ color: "var(--or)" }}>{c?.label}</p>
          <h2 className="h h2" style={{ marginTop: 20, maxWidth: 1200 }}>
            {c?.title} <span className="ac">{c?.title_accent}</span>
          </h2>
        </div>
        <p className="lb">{c?.stat}</p>
      </div>

      {projects.length === 0 ? (
        <div className="wrap" style={{ paddingBottom: 80 }}>
          <p className="lead mut">{c?.empty_text}</p>
        </div>
      ) : (
        <div className="cases">
          {projects.map((p, i) => (
            <Link to={`/casos/${p.id}`} key={p.id} className={`case${p.wide ? " w" : ""}`} data-testid={`case-card-${i}`}>
              {p.image_url && <img src={resolveImg(p.image_url)} alt={`${p.brand} — ${p.title}`} />}
              <span className="n">{p.num}</span>
              <div className="t">
                <p className="meta">{p.category}</p>
                <h3>
                  {p.brand}
                  <small>{p.title}</small>
                </h3>
              </div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
};
